'use client';
import './SimpleHero.css';
// import { SimpleHero } from 'trimble-terra/SimpleHero';
import { SimpleHero } from 'trimble-terra';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { formatThemePreset } from '@/lib/formatThemePreset';

const FormatSimpleHero = ( data: any, draftEnabled: boolean,  ) => {
  const formattedHero = {
    eyebrow: data?.data?.eyebrow,
    header: data?.data?.header,
    subheader: data?.data?.subheader,
    description: documentToReactComponents(data?.data?.description?.json),
    backgroundImage: data?.data?.backgroundImage?.image,
    overlayOption: data?.data?.overlayOption ? data?.data?.overlayOption?.toLowerCase() : "none",
    headerElement: "h1",
    isHeaderBig: data?.data?.isHeaderBig,
    isWrapped: true,
    presetTheme: data?.data?.theme ? formatThemePreset(data?.data?.theme) : "t2-preset-theme-one",
    buttons: data?.data?.buttons?.length ? data?.data?.buttons : undefined
  };

  return (
    <div className="mx-auto simple-hero-section">
      <SimpleHero {...formattedHero} /> 
    </div>
  );
}
export default FormatSimpleHero;
